// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { Popular } from '../Popular'
import './styles.scss'

export class Section3 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section three'>
       <div className="wrapper">
        <h2>Voici les races les plus populaires</h2>

        <div className='two-column'>
            <div className={'column left'} key={'left'}>
              <div className='txt'>
                <p>
                  Les Suisses et Suissesses préfèrent les petits chiens, comme les bichons maltais, mesurant moins de 45 centimètres et pesant moins de 15 kilos. Viennent ensuite les grands chiens comme les labradors, puis les chiens de taille moyenne comme les border collies. Les chiens très grands, comme les dogues allemands, sont beaucoup moins populaires.
                </p>
              </div>
              <div className="chart">
                <Popular />
              </div>
              <div className='txt'>
                <p>
                  Ce n'est donc pas surprenant qu'un petit chien arrive en tête du classement des races les plus populaires (sans compter les bâtards et les croisements): le chihuahua. Il s’agit de la plus petite race de chien du monde. La Suisse en compte un peu moins de 29’000. Il est suivi de près par le labrador, avec un peu plus de 25’000 individus. Le Yorkshire terrier (18'000) arrive en troisième position.
                </p>
                <p>
                  Les chihuahuas sont populaires en Suisse et ce depuis longtemps. Mais leur nombre n'a augmenté que de 24% par rapport à 2016. D'autres races ont connu une croissance nettement plus importante: le nombre de spitz nains, par exemple, a augmenté de plus de 200%; celui des bouledogues français a presque doublé. Il est intéressant de noter qu’il s’agit là de deux races de petite taille. Par rapport aux grands chiens, les petits coûtent en effet souvent moins chers, sont plus faciles à transporter et sont aussi plus souvent admis dans les appartements en location.
                </p>
              </div>
            </div>

            <div className={'column right'} key={'right'}>
              <div className="chart">
                <AutofitIFrame
                  src={'https://datawrapper.dwcdn.net/SkXvD/1/' + '?dark=' + String(this.props.colorMode === 'dark')}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
  }
}
